/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */

import type { McpClientId } from '../mcpConnect/types';
import type { McpCatalogEntry } from './entries';

export type CatalogFilters = { query: string; tag: string | null; client: McpClientId | null };
export const NO_FILTERS: CatalogFilters = { query: '', tag: null, client: null };

export function filterEntries(entries: McpCatalogEntry[], f: CatalogFilters): McpCatalogEntry[] {
  const q = f.query.trim().toLowerCase();
  return entries.filter(e =>
    (!q || [e.descriptor.title, e.provider, e.description ?? '', ...e.tags].some(s => s.toLowerCase().includes(q))) &&
    (!f.tag || e.tags.includes(f.tag)) &&
    (!f.client || e.descriptor.clients.includes(f.client)),
  );
}
